// @ts-nocheck
import axios from '../utils/axios';
import { ONLINE_REPORT_SERVICE_API_ENDPOINT } from '../config';
import { catchAsync } from '../utils/api';

const getTicketInfo = catchAsync(async ticketId => {
    const result = await axios.get(`${ONLINE_REPORT_SERVICE_API_ENDPOINT}/ticket/${ticketId}`, {
        headers: { 'x-lang': 'eng' },
    });

    return result.data;
});

const CashierService = {
    getTicketInfo,
};

export default CashierService;
